var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectx1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7283 8.01601V42.0334C43.7283 42.8127 43.0959 43.4452 42.317 43.4452H10.6528C9.87354 43.4452 9.24109 42.8127 9.24109 42.0334L9.22901 1.31873C9.22791 0.944094 9.37659 0.58484 9.6421 0.320435C9.9065 0.054932 10.2658 -0.09375 10.6404 -0.09375H35.6186C35.8541 -0.09375 36.0818 -0.0355223 36.2851 0.0736087C36.4056 0.137696 36.5173 0.22046 36.6161 0.319337L43.3142 7.01735C43.4735 7.17665 43.591 7.36928 43.6588 7.57912C43.7049 7.71864 43.7283 7.86623 43.7283 8.01601Z",
    fill: "#DFF1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6585 7.57912C43.5908 7.36928 43.4732 7.17665 43.3139 7.01735L36.6159 0.319337C36.517 0.22046 36.4053 0.137696 36.2848 0.0736087C36.0816 -0.0355223 35.8538 -0.09375 35.6183 -0.09375H24.146V43.4452H42.3167C43.0956 43.4452 43.7281 42.8127 43.7281 42.0334V8.01601C43.7281 7.86623 43.7046 7.71864 43.6585 7.57912Z",
    fill: "#CDE9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6588 7.57906L37.8518 7.56148C36.9861 7.55745 36.2852 6.85542 36.2852 5.98896V0.0735474C36.4056 0.137634 36.5173 0.220398 36.6162 0.319275L43.3142 7.01729C43.4735 7.17659 43.5911 7.36922 43.6588 7.57906Z",
    fill: "#ADDBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9988 28.7212C8.7096 28.7212 4.40625 33.0241 4.40625 38.3137C4.40625 43.6029 8.70924 47.9063 13.9988 47.9063C19.2884 47.9063 23.5913 43.6029 23.5913 38.3137C23.5913 33.0241 19.2884 28.7212 13.9988 28.7212Z",
    fill: "#FFD86E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2077 15.4425H17.7C16.9207 15.4425 16.2886 14.8104 16.2886 14.0311C16.2886 13.2514 16.9207 12.6194 17.7 12.6194H28.2077C28.987 12.6194 29.619 13.2514 29.619 14.0311C29.619 14.8104 28.987 15.4425 28.2077 15.4425Z",
    fill: "#CDE9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2076 12.6194H24.146V15.4425H28.2076C28.9869 15.4425 29.619 14.8104 29.619 14.0311C29.619 13.2514 28.9869 12.6194 28.2076 12.6194Z",
    fill: "#ADDBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7006 20.9948H17.7C16.9207 20.9948 16.2886 20.3627 16.2886 19.583C16.2886 18.8033 16.9207 18.1716 17.7 18.1716H34.7006C35.4799 18.1716 36.112 18.8033 36.112 19.583C36.112 20.3627 35.4803 20.9948 34.7006 20.9948Z",
    fill: "#CDE9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7006 18.1716H24.146V20.9948H34.7006C35.4803 20.9948 36.112 20.3627 36.112 19.583C36.112 18.8033 35.4803 18.1716 34.7006 18.1716Z",
    fill: "#ADDBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7006 26.5462H17.7C16.9207 26.5462 16.2886 25.9145 16.2886 25.1349C16.2886 24.3552 16.9207 23.7235 17.7 23.7235H34.7006C35.4799 23.7235 36.112 24.3552 36.112 25.1349C36.112 25.9145 35.4803 26.5462 34.7006 26.5462Z",
    fill: "#CDE9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7006 23.7235H24.146V26.5462H34.7006C35.4803 26.5462 36.112 25.9145 36.112 25.1349C36.112 24.3552 35.4803 23.7235 34.7006 23.7235Z",
    fill: "#ADDBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.343 42.461C11.9475 42.461 11.5549 42.2958 11.2758 41.9743L8.36482 38.6172C7.85395 38.0283 7.91731 37.137 8.50618 36.6261C9.09541 36.1156 9.98677 36.179 10.4976 36.7678L12.5122 39.0911L17.3099 35.1854C17.9142 34.6932 18.8033 34.7841 19.2955 35.389C19.7877 35.9933 19.6965 36.8825 19.0919 37.3746L13.2332 42.1442C12.9721 42.357 12.6568 42.461 12.343 42.461Z",
    fill: "#FFB509"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectx1);
export default __webpack_public_path__ + "static/media/correctx1.deaf8b5ec9d727bc08ac952f040ec180.svg";
export { ForwardRef as ReactComponent };